// wagmiConfig — wagmi 3.x configuration with EVM connectors
// Pure config setup: injected (EIP-6963), WalletConnect v2, Coinbase Wallet

import { createConfig, http } from 'wagmi';
import type { Config } from 'wagmi';
import type { Chain } from 'viem';
import { injected, walletConnect, coinbaseWallet, metaMask } from 'wagmi/connectors';
import { mainnet, polygon, arbitrum, optimism, base, bsc, avalanche, hyperEvm } from 'wagmi/chains';
import { WC_APP_METADATA, WC_RELAY_URL } from '../../config.ts';

const PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string;

// --- EVM chains ---

const CHAINS: readonly [Chain, ...Chain[]] = [mainnet, polygon, arbitrum, optimism, base, bsc, avalanche, hyperEvm];

// --- Connectors ---

const connectors = [
  injected({ shimDisconnect: true }),
  metaMask({ dapp: { name: 'ChainSale', url: WC_APP_METADATA.url } }),
  walletConnect({
    projectId: PROJECT_ID,
    showQrModal: true,
    relayUrl: WC_RELAY_URL,
    metadata: {
      name: WC_APP_METADATA.name,
      description: WC_APP_METADATA.description,
      url: WC_APP_METADATA.url,
      icons: [...WC_APP_METADATA.icons],
    },
  }),
  coinbaseWallet({ appName: 'ChainSale' }),
];

// --- Per-chain transports (public RPCs, can add custom later) ---

const transports = Object.freeze({
  [mainnet.id]: http(),
  [polygon.id]: http(),
  [arbitrum.id]: http(),
  [optimism.id]: http(),
  [base.id]: http(),
  [bsc.id]: http(),
  [avalanche.id]: http(),
  [hyperEvm.id]: http(),
});

// --- Config ---

export const wagmiConfig: Config<typeof CHAINS> = createConfig({
  chains: CHAINS,
  connectors,
  transports,
  multiInjectedProviderDiscovery: true,
});
